import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\components\\ToolbarButton.tsx.esbuild-plugin-linaria.css';
import { css, cx } from '@linaria/core';
import { memo } from 'preact/compat';
import { StyleType } from '../../doodle/view/StyleType';
import { COLOR_DANGER } from '../colors';
import { cssToolbarButtonLike } from './cssToolbarButtonLike';
export const ToolbarButton = memo(({
  type,
  className,
  style,
  title,
  disabled,
  active,
  priority,
  children,
  onClick
}: {
  type?: 'submit';
  className?: string;
  style?: StyleType;
  title?: string;
  disabled?: boolean;
  active?: boolean;
  priority?: 'danger';
  onClick?: (event: preact.TargetedMouseEvent<HTMLButtonElement>) => unknown;
  children: any;
}) => <button type={type || 'button'} title={title} disabled={disabled} className={cx(cssToolbarButtonLike, active && 'active', priority === 'danger' && "b1o7isbf", className)} style={style} onClick={onClick}>
      {children}
    </button>);